module.exports = __webpack_public_path__ + "media/images/fb_icon-c55a062fd414d3f99b6625c4f7494f12.png";